import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70f9fc3d")

_pushScopeId("data-v-70f9fc3d")
const _hoisted_1 = { class: "alert-frame" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_alert_item = _resolveComponent("alert-item")

  return (_openBlock(), _createBlock(_Teleport, { to: "#alert" }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        name: "custom-classes-transition",
        "enter-active-class": "animated fastest slideInRight",
        "leave-active-class": "animated fastest slideOutRight"
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
            return (_openBlock(), _createBlock(_component_alert_item, {
              key: error.id,
              type: error.errorType,
              message: error.message,
              onClose: ($event: any) => (_ctx.manualRemove(error.id))
            }, null, 8, ["type", "message", "onClose"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
})